import PlanningOrder, { POResourceName, Statuses } from 'volta/models/planning-order';
import { SkuResourceName } from 'volta/models/sku';
import { defaultErrorHandler } from 'volta/utils/error-utils';
import { inFilter } from 'volta/utils/filters-utils';

import { action } from '@ember/object';
import { Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type PlanningModel from 'volta/models/planning';
import type Planning from 'volta/models/planning';
import type IntlService from 'ember-intl/services/intl';
import type StoreService from 'volta/services/store';
interface Args {
  planning: Planning;
  isSelected: boolean;
  onTransition?: (planning: PlanningModel) => void;
}

export default class PlanningItem extends Component<Args> {
  // Services
  // ~~~~~
  @service router!: Router;
  @service intl!: IntlService;
  @service store!: StoreService;

  @tracked posForSyncAlerts: PlanningOrder[] = [];

  skuResourceName = SkuResourceName;

  // Computed Properties
  // ~~~~~

  get bufferZoneClassName() {
    return `buffer-zone-${this.args.planning.priorityName}`;
  }

  get acqCodeLabel() {
    return this.intl.t(`acqCodes.${this.args.planning.skuInfo.acqCode}`);
  }

  get skuModalState() {
    const { skuId, part, acqCode, unitMeasure } = this.args.planning.skuInfo;
    return {
      skuId,
      partCode: part.code,
      skuDescription: part.description,
      acqCode,
      options: {
        unitMeasure
      }
    };
  }

  @action
  async handleShowSyncAlerts(open: boolean) {
    try {
      if (open) {
        const pos: PlanningOrder[] = (
          await this.store.query(POResourceName.singular, {
            groupBy: 'sku',
            filter: {
              sku: inFilter([this.args.planning.skuInfo.skuId]),
              status: inFilter([Statuses.NEW.value])
            }
          })
        ).toArray();
        this.posForSyncAlerts = pos;
      } else {
        this.posForSyncAlerts = [];
      }
    } catch (error) {
      defaultErrorHandler(error);
    }
  }
}
